module.exports = __webpack_public_path__ + "img/laod.f02f9fa9.png";